import { ApiModule, type ApiResponse } from '@core';
import type { HeightmapQueryData, ParcelHeightmapItem } from '../models';

export class HeightmapApi extends ApiModule {
  protected endpoint = '/maximap/heightmap';

  public getHeightmaps(): Promise<ApiResponse<ParcelHeightmapItem[]>> {
    return this.api.get<ParcelHeightmapItem[]>(`${this.endpoint}`);
  }

  public loadHeightmapLayer(id: string): Promise<ApiResponse<any>> {
    return this.api.get<any>(`${this.endpoint}/${id}`);
  }

  public deleteHeightmap(id: string) {
    return this.api.delete(`${this.endpoint}/${id}`);
  }

  public queryHeightmapData(params: HeightmapQueryData): Promise<ApiResponse<ParcelHeightmapItem[]>> {
    return this.api.get<ParcelHeightmapItem[]>(`${this.endpoint}/candidates`, { params });
  }

  public getHeightmapCandidate(id: string): Promise<ApiResponse<any>> {
    return this.api.get<any>(`${this.endpoint}/candidates/${id}`);
  }

  public saveHeightmap(params: HeightmapQueryData): Promise<ApiResponse<void>> {
    return this.api.post<void, HeightmapQueryData>(`${this.endpoint}/assign`, params);
  }

  public downloadHeightmapLayers(data: any): Promise<ApiResponse<Blob>> {
    return this.api.get<Blob>(`${this.endpoint}/download`, {
      params: data,
      responseType: 'blob'
    });
  }
}
